export enum SettingsScreenNames {
  MAIN = 'settings-nav',
  SETTINGS = 'settings',
}
